import { render, staticRenderFns } from "./AssignAgent.vue?vue&type=template&id=45623ac8"
import script from "./AssignAgent.vue?vue&type=script&lang=ts"
export * from "./AssignAgent.vue?vue&type=script&lang=ts"
import style0 from "./AssignAgent.vue?vue&type=style&index=0&id=45623ac8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports